import { jsPDF } from "jspdf";
import { DocumentExportMetadata } from "../models/DocumentExportOptions";

const GREEN = [3, 125, 65] as const;

export const drawPdfDocumentHeader = (
  document: jsPDF,
  metadata: DocumentExportMetadata,
  compact = false,
) => {
  const pageWidth = document.internal.pageSize.getWidth();
  document.setTextColor(...GREEN);
  document.setFont("helvetica", "bold");
  document.setFontSize(compact ? 9 : 11);
  document.text("FrontLine", 14, compact ? 12 : 14);

  if (compact) {
    document.setTextColor(71, 85, 105);
    document.setFont("helvetica", "normal");
    document.text(metadata.title, pageWidth - 14, 12, { align: "right" });
    document.setDrawColor(220, 226, 232);
    document.line(14, 16, pageWidth - 14, 16);
    return 22;
  }

  if (metadata.confidential) {
    document.setFillColor(185, 28, 28);
    document.setTextColor(255, 255, 255);
    document.setFontSize(9);
    document.roundedRect(pageWidth - 48, 8, 34, 9, 1, 1, "F");
    document.text("CONFIDENTIAL", pageWidth - 31, 14, { align: "center" });
  }

  document.setTextColor(23, 32, 51);
  document.setFontSize(18);
  document.text(metadata.title, 14, 27);
  let y = 35;

  const context = [metadata.organisationName, metadata.serviceName].filter(Boolean).join("  |  ");
  if (context) {
    document.setFont("helvetica", "normal");
    document.setFontSize(10);
    document.setTextColor(71, 85, 105);
    document.text(context, 14, y);
    y += 6;
  }

  if (metadata.subtitle) {
    document.setFontSize(9);
    document.text(metadata.subtitle, 14, y);
    y += 6;
  }

  document.setDrawColor(3, 125, 65);
  document.setLineWidth(0.5);
  document.line(14, y, pageWidth - 14, y);
  return y + 7;
};
